import { legionEmissaryQuests } from './emissaryQuests';

export const legionTasks = [legionEmissaryQuests];
